<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="contract.product_name+' for '+contract.seller_name+' [Delete Product Contract]  - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>

                    <li class="breadcrumb-item">
                        <router-link :to="`/products/view/${contract.product_id}`">{{ contract.product_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contract.seller_type == 'Agent'">
                        <router-link :to="`/agents/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item" v-else-if="contract.seller_type == 'Agency'">
                        <router-link :to="`/agencies/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/contracts/view/${contract.id}`">
                            {{ contract.writing_nbr ? contract.writing_nbr : 'View Contract' }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <i class="fa fa-trash"></i> Delete
                    </li>

                </ol>
            </nav>

            <h4 class="page-header">
                Delete: {{ contract.product_name }} for {{ contract.seller_name }}
            </h4>

            <div class="row mb-3">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Delete Contract:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this contract. This will <strong>permanently delete this data.</strong> This action cannot be undone.

                                <div class="mt-3">
                                    <label>Type "delete" to confirm deletion:</label>
                                    <b-form-input v-model="confirm_delete" size="sm" placeholder="Type 'delete' to confirm" />

                                    <div class="text-danger mt-2" v-if="errors.confirm_delete">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.confirm_delete">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteContract()">
                        Delete Contract
                    </button>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                confirm_delete: null,
                id: this.$route.params.id,
                userTimezone: this.$root.timezone,
                contract: {},
                errors: {},
            }
        },

        computed: {
            canEdit(){
                //Check Permissions
                return this.$root.hasPermission('contracts.manage');
            },
        },

        methods: {

            getContract(){
                //Send it
                this.$http.get('/contracts/view/' + this.id)
                    .then(response => {
                        //Set the contract
                        this.contract = response.data.contract;
                        this.files = response.data.files;
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteContract(){
                //Send it
                this.$http.post('/contracts/delete/' + this.id, {confirm_delete: this.confirm_delete})
                    .then(response => {
                        //Send to previous
                        if(this.contract.seller_type == 'Agent')
                        {
                            //Send back to the view
                            this.$router.push('/agents/view/'+this.contract.seller_id);
                        }
                        else
                        {
                            //Send back to the view
                            this.$router.push('/agencies/view/'+this.contract.seller_id);
                        }
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Delete Contract');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted() {
            //get the contract?
            this.getContract();
        }
    }
</script>
